import React, { useState } from 'react';
import { Clock, Plus, User, Users, Building2, Calendar, X } from 'lucide-react';
import ScheduleForm from './ScheduleForm';

const ScheduledMessages = () => {
  const [Open, setOpen] = useState(false)
  const [scheduledMessages, setScheduledMessages] = useState([
    {
      id: 1,
      recipient: {
        initials: 'SW',
        name: 'Sarah Williams',
        type: 'user',
        avatar: 'SW'
      },
      message: "Hi Sarah, just a reminder about tomorrow's project deadline. Let me know if you need any help!",
      schedule: {
        date: '12/15/2025',
        time: '09:00'
      },
      status: 'cancelled'
    },
    {
      id: 2,
      recipient: {
        initials: 'PA',
        name: 'Project Alpha Team',
        type: 'group',
        avatar: 'PA'
      },
      message: "Team meeting at 3 PM today. Please review the agenda before the call.",
      schedule: {
        date: '12/14/2025',
        time: '14:30'
      },
      status: 'cancelled'
    },
    {
      id: 3,
      recipient: {
        initials: 'AC',
        name: 'Acme Corp',
        type: 'client',
        avatar: 'AC'
      },
      message: "Following up on the Q4 report. We'll have it ready by Friday as discussed.",
      schedule: {
        date: '12/16/2025',
        time: '10:00'
      },
      status: 'cancelled'
    }
  ]);


  const AddScheduleMessage = (newMessageData) => {
    const newMessage = {
      id: scheduledMessages.length + 1, // Generate new ID
      recipient: {
        initials: getInitials(newMessageData.recipient),
        name: newMessageData.recipient,
        type: newMessageData.recipientType,
        avatar: getInitials(newMessageData.recipient)
      },
      message: newMessageData.message,
      schedule: {
        date: formatDate(newMessageData.scheduleDate),
        time: newMessageData.scheduleTime
      },
      status: 'scheduled' // Set status as scheduled
    };
    setScheduledMessages([...scheduledMessages, newMessage])
    setOpen(false)
  }
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '/');
  };

  // Update stats based on actual messages
  const stats = {
    scheduled: scheduledMessages.filter(msg => msg.status === 'scheduled').length,
    sent: scheduledMessages.filter(msg => msg.status === 'sent').length,
    cancelled: scheduledMessages.filter(msg => msg.status === 'cancelled').length
  };


  const getStatusColor = (status) => {
    switch (status) {
      case 'scheduled':
        return 'status-scheduled';
      case 'sent':
        return 'status-sent';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return '';
    }
  };

  const getRecipientIcon = (type) => {
    switch (type) {
      case 'user':
        return <User className="recipient-icon" />;
      case 'group':
        return <Users className="recipient-icon" />;
      case 'client':
        return <Building2 className="recipient-icon" />;
      default:
        return <User className="recipient-icon" />;
    }
  };

  return (
    <section className="scheduled-messages bg-gradient-to-b from-black via-slate-950 to-slate-900 ">
      {/* Background blobs */}
      <div className="scheduled-background text-gray-400">
        <div className="blob-right"></div>
        <div className="blob-left"></div>
      </div>

      <div className="scheduled-container">
        {/* Header */}
        <div className="scheduled-header">
          <div className="scheduled-badge">
            <Clock className="badge-icon" />
            <span className="badge-text">Scheduled Messages</span>
          </div>

          <h2 className="scheduled-title">
            Send Messages at the
            <br />
            <span className="gradient-text-cyan">Perfect Time</span>
          </h2>

          <p className="scheduled-subtitle">
            Schedule messages to be sent automatically. Never miss a birthday,
            deadline reminder, or important follow-up.
          </p>
        </div>

        {/* Schedule Button */}
        <div className="schedule-button-wrapper">
          {!Open && (

            <button className="schedule-button"
              onClick={() => setOpen(true)}>
              <Plus className="button-icon" />
              Schedule New Message
            </button>
          )}
          {Open && (

            <button className='schedule-button' onClick={() => setOpen(false)}>
              <X className="button-icon" />
              Cancel</button>
          )}
        </div>
        {Open && (
          <ScheduleForm
            onSchedule={AddScheduleMessage}
            onCancel={() => setOpen(false)} />
        )}

        {/* Messages Grid */}
        <div className="messages-grid">
          {scheduledMessages.map((message) => (
            <div key={message.id} className="message-card">
              {/* Card Header */}
              <div className="card-header">
                <div className="recipient-info">
                  <div className="recipient-avatar">
                    {message.recipient.initials}
                  </div>
                  <div className="recipient-details">
                    <h4 className="recipient-name">{message.recipient.name}</h4>
                    <div className="recipient-type">
                      {getRecipientIcon(message.recipient.type)}
                      <span className="type-text">{message.recipient.type}</span>
                    </div>
                  </div>
                </div>

                {/* Status Badge */}
                <div className={`status-badge ${getStatusColor(message.status)}`}>
                  {message.status}
                </div>
              </div>

              {/* Message Content */}
              <p className="message-content">
                {message.message}
              </p>

              {/* Schedule Info */}
              <div className="schedule-info">
                <div className="schedule-item">
                  <Calendar className="schedule-icon" />
                  <span>{message.schedule.date}</span>
                </div>
                <div className="schedule-item">
                  <Clock className="schedule-icon" />
                  <span>{message.schedule.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="messages-grid">
          {/* {scheduledMessages.map((message) => (
          // ... your existing message card JSX
        ))} */}
        </div>
        {/* Stats Cards */}
        <div className="stats-grid">
          <div className="stat-card scheduled bg-cyan-50 rounded-2xl p-6 shadow-lg border-2 border-gray-200 text-center">
            <div className="stat-number">{stats.scheduled}</div>
            <div className="text-gray-600">Scheduled</div>
          </div>

          <div className="stat-card sent bg-green-50 rounded-2xl p-6 shadow-lg border-2 border-gray-200 text-center">
            <div className="stat-number">{stats.sent}</div>
            <div className="text-gray-600">Sent</div>
          </div>

          <div className="stat-card cancelled bg-gray-50 rounded-2xl p-6 shadow-lg border-2 border-gray-200 text-center">
            <div className="stat-number">{stats.cancelled}</div>
            <div className="text-gray-600">Cancelled</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduledMessages;